import React from "react";
import {ColumnProps} from "types/models";
const columns: ColumnProps[] = [
  {
    title: "STT",
    dataIndex: "STT",
    show: true,
    render(value, record, index) {
      return <div>{index + 1}</div>;
    },
    width: 100,
    align: "center",
  },
  {
    title: "Tên bệnh sử",
    dataIndex: "benhSu",
    show: true,
    align: "left",
    width: 300,
  },
  {title: "Ghi chú", dataIndex: "ghiChu", show: true, align: "left"},
];
export {columns};
